import { SvgIcon } from '@mui/material';
import React from 'react';

const SLOShippingProblemIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="Calque_1"
        data-name="Calque 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 176.82 150"
        strokeWidth={0}
        fill="currentColor"
      >
        <g>
          <path d="m122.83,100.25v49.75H13.42V56.27h50.28l-10.2,17.68c-6.77,11.7,1.68,26.3,15.18,26.3h54.16Z" />
          <polygon points="78.62 30.41 66.7 51.09 13.42 51.09 29.15 30.41 78.62 30.41" />
        </g>
        <g>
          <path d="m161.43,73.39c-12.72-22.08-25.47-44.15-38.22-66.22-.46-.8-.97-1.59-1.56-2.3-5.88-7.11-16.94-6.33-21.73,1.6-3.24,5.36-6.3,10.84-9.43,16.26-9.7,16.8-19.4,33.61-29.12,50.41-1.48,2.56-2.4,5.25-2.11,8.23.71,7.48,6.29,12.5,13.83,12.51,12.75.01,25.5,0,38.25,0s25.41,0,38.11,0c1.36,0,2.69-.1,4-.45,8.74-2.33,12.61-12,7.97-20.05Zm-11.68,11.55c-9.4.01-18.8,0-28.21,0h-10.19c-12.57,0-25.14-.14-37.7.08-4.24.07-6.81-3.61-4.46-7.63,12.64-21.65,25.13-43.4,37.66-65.11.19-.32.37-.64.57-.96,1.96-3.17,5.94-3.2,7.84,0,2.52,4.23,4.94,8.52,7.4,12.78,10.26,17.77,20.52,35.55,30.79,53.32.59,1.02,1.13,2.04,1.06,3.26-.14,2.52-2.06,4.26-4.76,4.27Z" />
          <path d="m107.93,77.77c-.94-.94-1.41-2.09-1.41-3.45s.47-2.51,1.41-3.45c.94-.94,2.09-1.41,3.45-1.41s2.42.47,3.34,1.41c.91.94,1.37,2.09,1.37,3.45s-.46,2.51-1.37,3.45c-.92.94-2.03,1.41-3.34,1.41s-2.51-.47-3.45-1.41Zm6.99-53.77l-.87,39.25h-5.96l-.86-39.25h7.69Z" />
        </g>
      </svg>
    </SvgIcon>
  );
};

export default SLOShippingProblemIcon;
